/**
 * PC Native Instant Search - Standalone
 * Fully independent search overlay with predictive results.
 * Uses custom /search?view=pc-api endpoint for better search support.
 */
(function () {
  'use strict';

  var overlay = document.getElementById('PcSearchOverlay');
  var input = document.getElementById('PcSearchInput');
  var form = document.getElementById('PcSearchForm');
  var closeBtn = document.getElementById('PcSearchClose');
  var resultsArea = document.getElementById('PcSearchResultsArea');
  var sidebarEl = document.getElementById('PcSearchSidebar');
  var productsEl = document.getElementById('PcSearchProducts');
  var viewAllLink = document.getElementById('PcSearchViewAll');

  if (!overlay || !input) return;

  var searchIcon = overlay.querySelector('.pc-search-form__icon--search');
  var loadingIcon = overlay.querySelector('.pc-search-form__icon--loading');
  var debounceTimer = null;
  var searchType = form
    ? (form.querySelector('input[name="type"]') || {}).value ||
      'product,article,page,collection'
    : 'product,article,page,collection';
  var minChars = 2;

  // ============================================
  // Open / Close
  // ============================================
  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest('.pc-search-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        openSearch();
      }
    },
    true,
  ); // Use capture phase to fire before theme.js

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      input.focus();
    }, 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    input.value = '';
    resultsArea.style.display = 'none';
    sidebarEl.innerHTML = '';
    productsEl.innerHTML = '';
  }

  closeBtn.addEventListener('click', closeSearch);

  // Close on clicking dim background
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      closeSearch();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  // ============================================
  // Instant Search
  // ============================================
  input.addEventListener('input', function () {
    var query = this.value.trim();
    if (debounceTimer) clearTimeout(debounceTimer);

    if (query.length < minChars) {
      resultsArea.style.display = 'none';
      sidebarEl.innerHTML = '';
      productsEl.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(function () {
      fetchResults(query);
    }, 300);
  });

  function showLoadingIcon() {
    if (searchIcon) searchIcon.style.display = 'none';
    if (loadingIcon) loadingIcon.style.display = '';
  }

  function showSearchIcon() {
    if (searchIcon) searchIcon.style.display = '';
    if (loadingIcon) loadingIcon.style.display = 'none';
  }

  function fetchResults(query) {
    showLoadingIcon();
    var url =
      '/search?view=pc-api&q=' +
      encodeURIComponent(query) +
      '&type=' +
      searchType +
      '&options[prefix]=last';

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        var data = JSON.parse(text.trim());
        renderResults(data, query);

        Shopify.analytics.publish('predictive_search', {
          search_term: query,
        });
      })
      .catch(function (err) {
        console.error('Search error:', err);
      })
      .finally(function () {
        showSearchIcon();
      });
  }

  function renderResults(data, query) {
    var products = data.products || [];
    var collections = data.collections || [];
    var articles = data.articles || [];
    var pages = data.pages || [];

    var hasProducts = products.length > 0;
    var hasCollections = collections.length > 0;
    var hasArticlesOrPages = articles.length > 0 || pages.length > 0;

    var footer = resultsArea.querySelector('.pc-search-results__footer');

    if (!hasProducts && !hasCollections && !hasArticlesOrPages) {
      sidebarEl.innerHTML = '';
      sidebarEl.style.display = 'none';
      productsEl.innerHTML =
        '<p class="pc-search-no-results">No results found for "' +
        escapeHtml(query) +
        '"</p>';
      if (footer) footer.style.display = 'none';
      resultsArea.style.display = 'block';
      return;
    }

    sidebarEl.style.display = '';
    if (footer) footer.style.display = '';

    // Sidebar: collections + articles/pages
    var sidebarHtml = '';

    if (hasCollections) {
      sidebarHtml += '<div class="pc-search-group">';
      sidebarHtml += '<h4 class="pc-search-group__title">COLLECTIONS</h4>';
      collections.forEach(function (col) {
        sidebarHtml +=
          '<a href="' +
          col.url +
          '" class="pc-search-group__link">' +
          escapeHtml(col.title) +
          '</a>';
      });
      sidebarHtml += '</div>';
    }

    if (hasArticlesOrPages) {
      sidebarHtml += '<div class="pc-search-group">';
      sidebarHtml += '<h4 class="pc-search-group__title">BLOG & PAGES</h4>';
      articles.forEach(function (a) {
        sidebarHtml +=
          '<a href="' +
          a.url +
          '" class="pc-search-group__link">' +
          escapeHtml(a.title) +
          '</a>';
      });
      pages.forEach(function (p) {
        sidebarHtml +=
          '<a href="' +
          p.url +
          '" class="pc-search-group__link">' +
          escapeHtml(p.title) +
          '</a>';
      });
      sidebarHtml += '</div>';
    }

    sidebarEl.innerHTML = sidebarHtml;

    // Products
    var productsHtml = '';
    if (hasProducts) {
      productsHtml += '<h4 class="pc-search-group__title">PRODUCTS</h4>';
      productsHtml += '<div class="pc-search-products-grid">';
      products.forEach(function (product) {
        var imgSrc =
          product.image || 'https://placehold.co/200x200?text=No+Image';
        var price = product.price_formatted || formatMoney(product.price);
        productsHtml +=
          '<a href="' + product.url + '" class="pc-search-product">';
        productsHtml +=
          '<div class="pc-search-product__image"><img src="' +
          imgSrc +
          '" alt="' +
          escapeHtml(product.title) +
          '" loading="lazy"></div>';
        productsHtml += '<div class="pc-search-product__info">';
        productsHtml +=
          '<span class="pc-search-product__title">' +
          escapeHtml(product.title) +
          '</span>';
        productsHtml +=
          '<span class="pc-search-product__price">' + price + '</span>';
        productsHtml += '</div>';
        productsHtml += '</a>';
      });
      productsHtml += '</div>';
    }

    productsEl.innerHTML = productsHtml;

    // View All link
    if (viewAllLink) {
      viewAllLink.href =
        '/search?q=' +
        encodeURIComponent(query) +
        '&type=' +
        searchType +
        '&options[prefix]=last';
    }

    resultsArea.style.display = 'block';
  }

  // Form submit
  form.addEventListener('submit', function (e) {
    var query = input.value.trim();
    if (!query) {
      e.preventDefault();
      return;
    }
    // Let form submit naturally to /search?q=
    // Don't call closeSearch() — it clears input.value before the browser reads it
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  // ============================================
  // Utilities
  // ============================================
  function formatMoney(price) {
    if (typeof price === 'string') {
      var num = parseFloat(price);
      price = num;
    }
    // Shopify Liquid returns price in cents (e.g., 10500 = $105.00)
    if (typeof price === 'number' && price > 0) {
      var amount = (price / 100).toFixed(2);
      if (window.theme && theme.moneyFormat) {
        return theme.moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(price / 100))
          .replace(
            /\{\{\s*amount_with_comma_separator\s*\}\}/,
            amount.replace('.', ','),
          );
      }
      return '$' + amount;
    }
    return '';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
})();
